// extracted by mini-css-extract-plugin
export default {"tile":"CategoryTile_tile__kI5nn","icon":"CategoryTile_icon__xTUMf","label":"CategoryTile_label__s-+su"};